import React,{useState,useEffect,}from 'react'
import { Table,Space,Flex, } from 'antd';
import { useClientTypeListQuery } from '../../store/ReactWebSiteApi';
import ClientTypeAdd from './ClientTypeAdd';
import Main from '../../cpn/Main';
import {DeleteOutlined,LogoutOutlined} from '@ant-design/icons';
import ClientTypeEdit from './ClientTypeEdit';
import ClientTypeDel from './ClientTypeDel';
function ClientTypeList() {
    const [query,setQuery] = useState({
        ect_e_id:localStorage.getItem('e_id'),
        ect_state:'2',
        ect_name:'',
        ect_mode:''
    })
    const {data,isSuccess} = useClientTypeListQuery(query,{refetchOnMountOrArgChange:1})
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                //console.log(data);
                const newArr = data.Result.map(item => {
                    const {ect_id:key,ect_name,ect_content,ect_uname,ect_ctime,ect_update_ctime,ect_update_uname,num,ect_state} = item;
                    return item = {key,ect_name,ect_content,ect_uname,ect_ctime,ect_update_ctime,ect_update_uname,num,ect_state}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.ect_ctime;
                    let bTimeString = b.ect_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])      
    const columns = [
        {
            key: 'type',
            title: '客户类型名称',
            dataIndex: 'ect_name',
        },           
        {
            key: 'ect_content',
            title: '备注',
            dataIndex: 'ect_content',
        },           
        {
            key: 'num',
            title: '客户数量',
            dataIndex: 'num',
        }, 
        {
            key: 'id',
            title: '编号',
            dataIndex: 'key'
        },      
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>
                    <div>新建时间：{record.ect_ctime + record.ect_uname}</div>
                    <div>修改时间：</div>
                </>
            }
        },
        {
            key: 'action',
            title:'操作',
            render: (_, record) => {
                return <>
                    <Space>                        
                        <ClientTypeEdit
                            ect_id={record.key}
                            ect_state={record.ect_state}
                        />
                        <ClientTypeDel
                            ect_id={record.key}
                            ect_state={record.ect_state}
                            num={record.num}
                        />
                    </Space>
                    
                </>
            }
        },
    ]
    
    return (
        <Main t1='客户类型'>
            {query.ect_state==='2' ? <Flex justify='space-between' align='center'>
                <ClientTypeAdd /><a 
                    style={{
                        marginRight:"20px",
                        fontSize:"18px"
                    }}
                    onClick={() => {
                        setQuery(prevState=>({...prevState,ect_state:'1'}))
                    }}
                ><DeleteOutlined /> 已删除客户类型</a>
            </Flex>:<Flex>
                        <a 
                            style={{
                                fontSize:"18px"
                                }}
                            onClick={() => {
                                setQuery(prevState=>({...prevState,ect_state:'2'}))
                            }}
                        ><LogoutOutlined /> 未删除客户类型</a>
                        </Flex>
                    }
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{position:['none']}}
                style={{marginTop:"20px"}}
            />          
        </Main>
    )
}

export default ClientTypeList